<template>
    <div class="bi-com bi-cb">
        <div class="bi-cb-icon-wrapper">
            <img
                class="img-fluid bi-cb-icon"
                src="../../../assets/icon/checkbox_active.png"
                v-show="isActive"
                @click="toggleCheckBox()" />
            <img
                class="img-fluid bi-cb-icon"
                src="../../../assets/icon/checkbox_inactive.png"
                v-show="!isActive"
                @click="toggleCheckBox()" />
        </div>
        <label class="bi-cb-lbl">{{textLbl}}</label>
    </div>    
</template>
<script>
export default {
    name: "CheckBox",
    props: {
        //v-model
        value: Boolean,
        //props
        textLbl: String
    },
    data: function () {
        return {
            isActive: this.value
        };
    },
    methods: {
        toggleCheckBox: function () {
            this.isActive = !this.isActive;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/baseinput.scss";
</style>